<template>
  <span class="scaling-svg-container">
    <svg
      data-name="Icon/Arrowhead Left"
      xmlns="http://www.w3.org/2000/svg"
      width="14.375"
      height="14.376"
      viewBox="0 0 14.375 14.376"
      class="scaling-svg"
    >
      <path
        data-name="Icon/Icon/Arrowhead-left"
        d="M13.172,14.376a1.022,1.022,0,0,1-.8-.383L7.414,7.832a1.031,1.031,0,0,1,.012-1.3L12.56.37a1.027,1.027,0,1,1,1.579,1.314L9.542,7.2l4.431,5.506a1.026,1.026,0,0,1-.8,1.67Zm-7.188,0a1.016,1.016,0,0,1-.8-.383L.227,7.831a1.028,1.028,0,0,1,.012-1.3L5.372.369A1.027,1.027,0,1,1,6.95,1.684L2.353,7.2,6.784,12.7a1.027,1.027,0,0,1-.8,1.671Z"
        transform="translate(-0.001 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowDoubleLeftIcon extends Vue {}
</script>

<style>
</style>
